import { cn } from 'lib/utils'
import { RadioGroup, RadioGroupItem } from './base/radio-group'
import { Label } from './label'

export interface RadioGroupComponentProps {
  name: string
  options: { label: string | React.ReactNode; value: string }[]
  value: string
  label?: string | React.ReactNode
  onChange: (value: string) => void
  optionsClassName?: string
  optionClassName?: string
  labelClassName?: string
  disabled?: boolean
}

export const RadioGroupComponent: React.FC<RadioGroupComponentProps> = ({
  name,
  options,
  label,
  value,
  onChange,
  optionsClassName,
  optionClassName,
  labelClassName,
  disabled,
  ...props
}) => (
  <RadioGroup value={value} onValueChange={onChange} name={name} disabled={disabled} {...props}>
    {label && <Label>{label}</Label>}
    <div className={cn('flex gap-12', optionsClassName)}>
      {options.map((option) => {
        const isChecked = value === option.value
        return (
          <div
            className={cn(
              'flex items-start space-x-2 w-fit',
              optionClassName,
              isChecked && 'checked',
              disabled && 'opacity-50 cursor-not-allowed',
            )}
            key={option.value}
          >
            <RadioGroupItem
              value={option.value}
              id={`r${option.value}`}
              className="mt-1 flex-shrink-0"
              disabled={disabled}
            />
            <Label
              htmlFor={`r${option.value}`}
              className={cn('text-p-500', labelClassName, disabled && 'cursor-not-allowed')}
            >
              {option.label}
            </Label>
          </div>
        )
      })}
    </div>
  </RadioGroup>
)
